<template>
  <div class="increment" style="padding-top: 50px;">
    <img src="../../static/image/service_capability.png" class="fullWidth" />
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <div style="height: 80px;"></div>
        <div class="alignCenter fontfaYahei color33 font36">金质服务</div>
        <div style="height: 30px;"></div>
        <div class="Gold_service">
          <ul>
            <li>
              <div class="Gold_service_content">
                <h2>售前服务：</h2>
                <p>1、技术咨询服务</p>
                <p>2、需求分析服务</p>
                <p>3、提供简要产品方案</p>
                <p>4、提供项目实施方案及报价</p>
                <p>5、洽谈及签订合同</p>
              </div>
              <div class="left_top">
                <img src="../../static/image/service1.png" alt />
              </div>
            </li>
            <li>
              <div class="Gold_service_content">
                <h2>售中服务：</h2>
                <p>1、项目进度及时反馈</p>
                <p>2、设计方案讲解确认</p>
                <p>3、项目相关事项清单</p>
                <p>4、协助申请各类第三方账号</p>
                <p>5、交付培训及技术指导</p>
              </div>
              <div class="left_top">
                <img src="../../static/image/service2.png" alt />
              </div>
            </li>
            <li>
              <div class="Gold_service_content">
                <h2>售后服务：</h2>
                <p>1、终身技术顾问</p>
                <p>2、一年售后保障</p>
                <p>3、持续优化建议</p>
                <p>4、服务器安全巡检</p>
                <p>5、服务器数据备份</p>
                <p>6、应急技术支持</p>
              </div>
              <div class="left_top">
                <img src="../../static/image/service3.png" alt />
              </div>
            </li>
          </ul>
        </div>
      </Col>
    </Row>
    <div class="Service_concept">
      <div class="Service_concept_content">
        <div class="Service_concept_left">
          <img src="../../static/image/Service_concept.png" alt />
        </div>
        <div class="Service_concept_right">
          <h2>服务理念</h2>
          <p style="margin:10px 0">选择既是信任，客户的信任既是我们砥砺前行的动力，更是我们无法计算的财富；</p>
          <p>我们希望每一次交流，都能输出有价值的信息和建议；</p>
          <p>我们希望每一次合作，都是我们持续输出价值的开始；</p>
          <p>我们希望每一次交付，都能为客户带来惊喜和能量；</p>
          <p>我们希望通过我们的服务和技术，赋能客户、推动行业发展；</p>
          <p>我们将努力让每一位客户省钱、省时、省心、省力。</p>
        </div>
      </div>
    </div>
    <div class="added_service">
      <div class="alignCenter fontfaYahei color33 font36">9大增值服务</div>
      <ul class="added_service_list">
        <li>
          <img src="../../static/image/added_service1.png" alt />
          <p>
            送200元模板软件代金券
          </p>
        </li>
        <li>
          <img src="../../static/image/added_service2.png" alt />
          <p>协助申请软件著作权</p>
        </li>
        <li>
          <img src="../../static/image/added_service3.png" alt />
          <p>协助申请商标</p>
        </li>
        <li>
          <img src="../../static/image/added_service4.png" alt />
          <p>协助上架APP到应用商店</p>
        </li>
        <li>
          <img src="../../static/image/added_service5.png" alt />
          <p>协助进行域名注册和备案</p>
        </li>
      </ul>
      <ul class="added_service_list">
        <li>
          <img src="../../static/image/added_service6.png" alt />
          <p>送1200元400电话代金券</p>
        </li>
        <li>
          <img src="../../static/image/added_service7.png" alt />
          <p>协助申请各类平台账号</p>
        </li>
        <li>
          <img src="../../static/image/added_service8.png" alt />
          <p>支付通道代申请</p>
        </li>
        <li>
          <img src="../../static/image/added_service9.png" alt />
          <p>协助获得政府政策支持</p>
        </li>
        <li>
          <img src="../../static/image/added_service10.png" alt />
          <p>更多</p>
        </li>
      </ul>
    </div>
    <div class="tel_advantage">
    </div>
    <xfck></xfck>
    <tankuang ref="tankuang"></tankuang>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
import tankuang from "./tankuang.vue";
var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }
export default {
  name: "increment",
  data() {
    return {};
  },
  methods: {
    showed() {
      this.$refs.tankuang.show = true;
    }
  },
  components: {
    xfck,
    tankuang
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.masgin:nth-child(1) {
  margin-left: 135px;
}
.colorea {
  margin-left: 0px;
}
.Gold_service ul {
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}
.Gold_service ul li {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.09);
  width: 320px;
  height: 362px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.Gold_service ul li h2 {
  font-size: 18px;
  color: rgba(253, 123, 53, 1);
  font-weight: 400;
  font-family: MicrosoftYaHei;
}
.Gold_service ul li p {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  line-height: 24px;
  font-family: Microsoft YaHei;
}
.left_top {
  width: 80px;
  height: 80px;
  background: rgba(253, 123, 53, 1);
  position: absolute;
  left: 30px;
  top: -20px;
  text-align: center;
  line-height: 80px;
}
.left_top img {
  vertical-align: middle;
}
.Service_concept {
  background: rgba(245, 245, 245, 1);
  margin-top: 80px;
}
.Service_concept_content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.Service_concept_left {
  width: 424px;
  height: 332px;
  margin: 60px 70px;
}
.Service_concept_right {
  height: 332px;
  margin-top: 79px;
}
.Service_concept_right h2 {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.Service_concept_right p {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.added_service {
  padding: 30px;
}
.added_service_list {
  list-style: none;
  width: 1200px;
  margin: 90px auto;
  display: flex;
  justify-content: space-between;
}
.added_service_list li {
  width: 139px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.added_service_list li p {
  text-align: center;
  margin-top: 15px;
}
.added_service_list li img {
  width: 60px;
}
.tel_advantage {
  width: 100%;
  height: 567px;
  margin: 0 auto;
  display: none;
  background: url('../../static/image/tel_advantage.png')no-repeat top center;
  background-size: 100% 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/increment.vue